<template>
  <ProductListing
    :category-path-builder="productCategoryPathBuilder"
    :base-products-path-override="baseProductsPath"
  />
</template>

<script setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useLocalePath } from "#i18n";
import ProductListing from "~/components/products/ProductListing.vue";

definePageMeta({
  name: "products",
});

const { locale } = useI18n();
const localePath = useLocalePath();
const baseProductsPath = computed(
  () => localePath({ name: "products" }) || "/products"
);

const productCategoryPathBuilder = (slug) => {
  if (!slug) {
    return baseProductsPath.value;
  }
  const prefix = locale.value === "tr" ? "" : `/${locale.value}`;
  return `${prefix}/${encodeURIComponent(slug)}`;
};
</script>
